import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import API_BASE from '../api';

const POSITIONS = ['שוער', 'בלם', 'מגן', 'קשר', 'כנף', 'חלוץ'];
const WA_NUMBER = '9720546318704';

const C = {
  bg: '#04091a', card: 'rgba(10,20,45,0.7)', line: 'rgba(212,175,55,0.3)',
  gold: '#d4af37', goldLt: '#f0cc60', text: '#dbe2f0', dim: '#8a9aba', white: '#fff',
};

const input = {
  width: '100%', padding: '11px 14px', background: '#0a1525', color: C.white,
  border: '1px solid #2a3a6a', borderRadius: 10, fontSize: '1rem',
  direction: 'rtl', boxSizing: 'border-box', fontFamily: "'Heebo', sans-serif",
};
const label = { color: C.dim, fontSize: '0.84rem', fontWeight: 700, display: 'block', marginBottom: 6 };

function Shell({ children }) {
  return (
  <div style={{
    minHeight: '100vh', direction: 'rtl', fontFamily: "'Heebo', sans-serif",
    backgroundImage: "linear-gradient(180deg, rgba(4,9,26,0.9), rgba(4,9,26,0.96)), url('/family-hero.jpg')",
    backgroundSize: 'cover', backgroundPosition: 'center', padding: '0 0 40px',
  }}>
    <div style={{ textAlign: 'center', padding: '20px 16px 10px' }}>
      <img src="/ustarpro.png" alt="U-STAR Profile"
        style={{ width: 'min(300px,80%)', borderRadius: 12, border: `1px solid ${C.line}` }} />
    </div>
    <div style={{ maxWidth: 560, margin: '0 auto', padding: '0 16px' }}>{children}</div>
  </div>
);
}

function fmtDob(d) {
  const m = String(d || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${+m[3]}.${+m[2]}.${m[1]}` : (d || '');
}

export default function ClipOrderForm() {
  const { formId } = useParams();
  const [cfg, setCfg] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const [form, setForm] = useState({
    name: '', phone: '', email: '',
    player_first: '', player_last: '',
    dob_day: '', dob_month: '', dob_year: '',
    shirt: '',
  });
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    document.title = 'הזמנת קליפ כדורגל אישי | יוסטאר';
    axios.get(`${API_BASE}/clip-order-forms/${formId}/public`)
      .then(r => setCfg(r.data))
      .catch(() => setNotFound(true));
  }, [formId]);

  const set = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const togglePos = p => {
    setPositions(cur =>
      cur.includes(p) ? cur.filter(x => x !== p)
        : cur.length < 3 ? [...cur, p] : cur);
  };

  const submit = async e => {
    e.preventDefault();
    const pf = cfg && cfg.prefill;
    if (pf) {
      // טופס חוזר — הפרטים כבר שמורים בשרת, שולחים רק עמדה וחולצה
      setError(''); setSending(true);
      try {
        await axios.post(`${API_BASE}/clip-orders`, { formId, playerPositions: positions, playerShirt: form.shirt || null });
        setForm(f => ({ ...f, player_first: (pf.playerName || '').split(' ')[0] }));
        setDone(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        setError(err.response?.data?.error || 'שגיאה בשליחה, נסו שוב');
      } finally { setSending(false); }
      return;
    }
    if (!form.dob_year || !form.dob_month || !form.dob_day) { setError('יש למלא תאריך לידה מלא — יום, חודש ושנה'); return; }
    setError(''); setSending(true);
    try {
      const dob = form.dob_day && form.dob_month && form.dob_year
        ? `${form.dob_year}-${String(form.dob_month).padStart(2, '0')}-${String(form.dob_day).padStart(2, '0')}`
        : `${form.dob_year}-01-01`;
      await axios.post(`${API_BASE}/clip-orders`, {
        formId,
        name: `${form.name}`.trim(),
        phone: form.phone,
        email: form.email || null,
        playerName: `${form.player_first} ${form.player_last}`.trim(),
        playerBirthDate: dob,
        playerPositions: positions,
        playerShirt: form.shirt || null,
      });
      setDone(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בשליחה, נסו שוב');
    } finally { setSending(false); }
  };


  if (notFound) return (
    <Shell><div style={{ textAlign: 'center', color: C.text, marginTop: 40 }}>הטופס לא נמצא או אינו פעיל.</div></Shell>
  );
  if (!cfg) return (
    <Shell><div style={{ textAlign: 'center', color: C.dim, marginTop: 40 }}>טוען…</div></Shell>
  );

  if (done) return (
    <Shell>
      <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 18, padding: '30px 22px', textAlign: 'center', marginTop: 14 }}>
        <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>✅</div>
        <h1 style={{ color: C.white, fontSize: '1.4rem', margin: '0 0 10px' }}>ההזמנה נקלטה!</h1>
        <p style={{ color: C.text, lineHeight: 1.85, margin: '0 0 16px' }}>
          התחלנו לעבוד על הקליפ האישי של {form.player_first || 'השחקן/ית'}.
          <br/>
          <strong style={{ color: C.goldLt }}>הקליפ יהיה מוכן עד 3 ימי עבודה.</strong>
        </p>
        <div style={{ background: 'rgba(37,211,102,0.08)', border: '1px solid rgba(37,211,102,0.3)', borderRadius: 12, padding: '14px 16px', textAlign: 'right', marginBottom: 18 }}>
          <div style={{ color: C.text, fontSize: '0.9rem', lineHeight: 1.8 }}>
            📲 את הקליפ נשלח לוואטסאפ האישי שלך:
            <br/>• <strong style={{ color: C.white }}>קובץ להורדה ושמירה בפלאפון</strong>
            <br/>• <strong style={{ color: C.white }}>קישור יוטיוב פרטי</strong> לצפייה ולשיתוף
          </div>
        </div>
        <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noopener noreferrer"
          style={{ display: 'inline-block', background: '#25d366', color: '#fff', borderRadius: 30, padding: '12px 26px', textDecoration: 'none', fontWeight: 800 }}>
          💬 וואטסאפ יוסטאר
        </a>
      </div>
    </Shell>
  );

  return (
    <Shell>
      {/* כותרת + מה שנקבע מראש */}
      <div style={{ textAlign: 'center', margin: '6px 0 16px' }}>
        <div style={{ display: 'inline-block', background: 'rgba(212,175,55,0.12)', border: `1px solid ${C.line}`, borderRadius: 30, padding: '6px 18px', color: C.goldLt, fontWeight: 800, fontSize: '0.88rem' }}>
          🎬 הזמנת קליפ כדורגל אישי
        </div>
        <h1 style={{ color: C.white, fontWeight: 900, fontSize: 'clamp(1.4rem,5vw,1.9rem)', margin: '12px 0 4px' }}>
          {cfg.product || cfg.title || 'קליפ ביצועים אישי ממשחק מצולם'}
        </h1>
        <p style={{ color: C.dim, fontSize: '0.92rem', margin: 0 }}>{cfg.prefill ? 'הפרטים שלכם כבר אצלנו — רק עמדה ומספר חולצה ושלחו' : 'מלאו את הפרטים ונתחיל לעבוד על הקליפ'}</p>
      </div>

      {/* קבוצה · שכבה · מחיר — נעול */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 18 }}>
        {[['קבוצה', cfg.team], ['שכבת גיל', cfg.age_group], ['מחיר', `${cfg.price} ₪`]].map(([k, v]) => (
          <div key={k} style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: '12px 8px', textAlign: 'center' }}>
            <div style={{ color: C.goldLt, fontWeight: 900, fontSize: 'clamp(0.85rem,3vw,1.05rem)', lineHeight: 1.3 }}>{v}</div>
            <div style={{ color: C.dim, fontSize: '0.74rem', marginTop: 4 }}>{k}</div>
          </div>
        ))}
      </div>

      {error && (
        <div style={{ background: 'rgba(255,80,80,0.12)', border: '1px solid rgba(255,80,80,0.4)', color: '#ff9a9a', borderRadius: 10, padding: '10px 14px', marginBottom: 14, textAlign: 'center' }}>{error}</div>
      )}

      <form onSubmit={submit} style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 18, padding: '20px 18px' }}>
        {cfg.prefill ? (
          <div style={{ background: 'rgba(212,175,55,0.06)', border: `1px solid ${C.line}`, borderRadius: 12, padding: '14px 16px', marginBottom: 18 }}>
            <div style={{ color: C.gold, fontWeight: 800, fontSize: '0.92rem', marginBottom: 8 }}>✔ הפרטים שלכם</div>
            {[['הורה', cfg.prefill.name], ['טלפון', cfg.prefill.phone], ['אימייל', cfg.prefill.email],
              ['שחקן/ית', cfg.prefill.playerName], ['תאריך לידה', fmtDob(cfg.prefill.playerBirthDate)]]
              .filter(([, v]) => v).map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', gap: 10, padding: '4px 0', fontSize: '0.9rem' }}>
                  <span style={{ color: C.dim }}>{k}</span>
                  <span style={{ color: C.white, fontWeight: 700, direction: k === 'טלפון' || k === 'אימייל' ? 'ltr' : 'rtl' }}>{v}</span>
                </div>
              ))}
            <div style={{ color: C.dim, fontSize: '0.82rem', marginTop: 10 }}>⚽ עדכנו את מספר החולצה והעמדה במשחק הזה:</div>
          </div>
        ) : (<>
        {/* פרטי הלקוח */}
        <div style={{ color: C.gold, fontWeight: 800, fontSize: '0.95rem', marginBottom: 12 }}>👨‍👩‍👦 פרטי ההורה של השחקן/ית</div>
        <div style={{ marginBottom: 12 }}>
          <label style={label}>שם מלא של ההורה *</label>
          <input style={input} name="name" value={form.name} onChange={set} required placeholder="שם ההורה — פרטי ומשפחה" />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12, marginBottom: 4 }}>
          <div>
            <label style={label}>טלפון *</label>
            <input style={input} name="phone" value={form.phone} onChange={set} required type="tel" placeholder="05X-XXXXXXX" />
          </div>
          <div>
            <label style={label}>אימייל <span style={{ fontWeight: 400 }}>(לא חובה)</span></label>
            <input style={input} name="email" value={form.email} onChange={set} type="email" placeholder="example@email.com" />
          </div>
        </div>

        {/* פרטי השחקן */}
        <div style={{ color: C.gold, fontWeight: 800, fontSize: '0.95rem', margin: '22px 0 6px' }}>⚽ פרטי השחקן/ית לזיהוי במשחק</div>
        <div style={{ color: C.dim, fontSize: '0.82rem', marginBottom: 12 }}>כדי שנזהה אותו/ה בצילום ונבנה את הקליפ נכון</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12, marginBottom: 12 }}>
          <div><label style={label}>שם פרטי *</label><input style={input} name="player_first" value={form.player_first} onChange={set} required placeholder="שם פרטי" /></div>
          <div><label style={label}>שם משפחה *</label><input style={input} name="player_last" value={form.player_last} onChange={set} required placeholder="שם משפחה" /></div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={label}>תאריך לידה *</label>
          {/* RTL — שנה מימין, חודש באמצע, יום משמאל */}
          <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr', gap: 8 }}>
            <input style={{ ...input, textAlign: 'center' }} name="dob_year" value={form.dob_year} onChange={set} required type="number" min="2000" max="2022" placeholder="שנה" />
            <input style={{ ...input, textAlign: 'center' }} name="dob_month" value={form.dob_month} onChange={set} required type="number" min="1" max="12" placeholder="חודש" />
            <input style={{ ...input, textAlign: 'center' }} name="dob_day" value={form.dob_day} onChange={set} required type="number" min="1" max="31" placeholder="יום" />
          </div>
        </div>

        </>)}

        <div style={{ marginBottom: 12 }}>
          <label style={label}>מספר חולצה</label>
          <input style={input} name="shirt" value={form.shirt} onChange={set} type="number" min="1" max="99" placeholder="לדוגמה: 10" />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ ...label, marginBottom: 8 }}>עמדות במגרש <span style={{ fontWeight: 400 }}>(עד 3)</span></label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 9 }}>
            {POSITIONS.map(p => {
              const on = positions.includes(p);
              const full = positions.length >= 3 && !on;
              return (
                <button key={p} type="button" onClick={() => togglePos(p)} disabled={full}
                  style={{
                    padding: '8px 16px', borderRadius: 20, fontSize: '0.92rem', fontWeight: on ? 800 : 500,
                    cursor: full ? 'not-allowed' : 'pointer', fontFamily: "'Heebo', sans-serif",
                    border: `2px solid ${on ? C.gold : '#2a3a6a'}`,
                    background: on ? 'linear-gradient(135deg,#d4af37,#f0cc60)' : '#0a1525',
                    color: on ? '#0a1120' : (full ? '#4a5a7a' : '#ccc'),
                  }}>{on ? '✓ ' : ''}{p}</button>
              );
            })}
          </div>
        </div>

        <button type="submit" disabled={sending}
          style={{
            width: '100%', background: 'linear-gradient(135deg,#d4af37,#f0cc60)', color: '#0a1120',
            border: 'none', borderRadius: 12, padding: '14px', fontSize: '1.05rem', fontWeight: 900,
            cursor: sending ? 'default' : 'pointer', boxShadow: '0 6px 24px rgba(212,175,55,0.4)',
          }}>
          {sending ? '...שולח' : '🎬 שלח הזמנה'}
        </button>
        <div style={{ color: C.dim, fontSize: '0.82rem', textAlign: 'center', marginTop: 12 }}>
          אחרי השליחה ניצור קשר בוואטסאפ לתיאום ולתשלום
        </div>
      </form>

      <div style={{ textAlign: 'center', color: '#4a5a80', fontSize: '0.78rem', marginTop: 20 }}>
        © {new Date().getFullYear()} יוסטאר — מועדון הכוכבים
      </div>
    </Shell>
  );
}
